<app-admin-page-model routeName="Informations" pageTitle="Gestion du fil d'information">

  <app-create-information-action (onSave)="createInfo($event)"
                                 [info]="toCreate">
  </app-create-information-action>

  <app-list-informations class="row"
                         [infos]="$infos"
                         [search]="search"
                         (edit)="edit($event)"
                         (toArchive)="setToArchive($event)"
                         (toHistory)="setToHistory($event)"
                         (publish)="toPublish = $event"
  ></app-list-informations>

  <app-dynamic-modal-form
    [actions]="[{label: 'Confirmer', class: 'btn-info', icon:''}]"
    [object]="toMove"
    (onSubmit)="moveToDestination()"
    [title]="'Bascule vers ' + (toMoveDestivation === 'HISTORY' ? 'l\'historique' : 'les archives')">
    <ng-template>
      <p>
        Êtes-vous sûr de vouloir basculer l'information vers {{toMoveDestivation === 'HISTORY' ? 'l\'historique' : 'les archives'}} ?
      </p>
    </ng-template>
  </app-dynamic-modal-form>

  <app-dynamic-modal-form
    [actions]="[{label: 'Confirmer', class: 'btn-info', icon:''}]"
    [object]="toPublish"
    (onSubmit)="publishInfo()"
    (onCancel)="toPublish = undefined"
    [title]="'Publication de l\'information'">
    <ng-template>
      <p>
        Êtes-vous sûr de vouloir publier l'information ?
      </p>
    </ng-template>
  </app-dynamic-modal-form>
</app-admin-page-model>
